import React from "react";

/**
 * Apex brand-mark heartbeat loader.
 * Two flavours:
 *   - <ApexLoader />            → full-screen, dark background, tagline below the mark
 *   - <ApexLoader inline />     → inline pill (16px), no background, no tagline
 *
 * Animation: real heartbeat rhythm (lub-dub) on the mark itself, plus a soft
 * red pulse on the inner dot for added life. CSS-only — no Motion required.
 */

function HeartbeatMark({ size = 56 }) {
  // Sizing: keeps inner dot proportional whatever size you pass in
  const inset = Math.max(3, Math.round(size * 0.09));
  const dot = Math.max(4, Math.round(size * 0.16));
  return (
    <span
      className="relative inline-flex items-center justify-center apex-heartbeat"
      style={{ width: size, height: size }}
      data-testid="apex-loader-mark"
    >
      <span
        className="absolute inset-0 border border-white/30"
        style={{ borderWidth: 1 }}
      />
      <span
        className="absolute border border-[#dc2626]/70"
        style={{ inset, borderWidth: 1 }}
      />
      <span
        className="absolute bg-[#dc2626] rounded-full apex-heartbeat-dot"
        style={{ width: dot, height: dot }}
      />
    </span>
  );
}

export default function ApexLoader({
  inline = false,
  label = "loading",
  size,
}) {
  if (inline) {
    return <HeartbeatMark size={size || 16} />;
  }
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center gap-6 bg-[#0a0a0b]"
      data-testid="apex-loader"
    >
      <HeartbeatMark size={size || 64} />
      {label && (
        <div className="font-mono-apex text-[10px] uppercase tracking-[0.35em] text-zinc-500">
          {label}
        </div>
      )}
    </div>
  );
}

export { HeartbeatMark };
